import * as z from 'zod';
import { suretyAccountStatusSchema, suretyQuoteStatusSchema, contractSuretyAccountUnderwritingModelSizeSchema, suretyAccountUnderwritingStatusSchema } from '../../../../enums.mjs';
import '../../../../types/actor/actor.mjs';
import '../../../../types/address/address.mjs';
import '../../../../types/credit-report/company-credit-report.mjs';
import '../../../../types/credit-report/individual-credit-report.mjs';
import '../../../../types/currency/currency.mjs';
import '../../../../types/entityRelation/entity-relation.mjs';
import '../../../../types/financial-formula/adjustable-value.mjs';
import '../../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../../types/financial-formula/adjustment.mjs';
import '../../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../../types/is-encrypted.mjs';
import '../../../../types/naics-codes/naics-codes.mjs';
import { isoDateTimeSchema, userId, companyContactId, agencyId, suretyAccountId, suretyIndemnityAgreementId, suretyQuoteId, suretyAccountUnderwritingId } from '../../../../types/opaque.mjs';
import '../../../../types/surety/account/surety-account.types.mjs';
import '../../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../../types/surety/bond/surety-bond.types.mjs';
import '../../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../../types/surety/quote/surety-quote.types.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../../types/user/user.types.mjs';
import '../../../../types/utils.mjs';

var Account;
(function (Account) {
    let Get;
    (function (Get) {
        (function (Response) {
            Response.schema = z.object({
                id: suretyAccountId,
                agencyId,
                status: suretyAccountStatusSchema,
                displayName: z.string(),
                primaryCompanyId: companyContactId,
                underwriterUserId: userId,
                isPrequal: z.boolean(),
                fundNames: z.array(z.string()),
                indemnityAgreementId: suretyIndemnityAgreementId.optional(),
                closedReason: z.string().optional(),
                closedNote: z.string().optional(),
                createdAt: isoDateTimeSchema,
                updatedAt: isoDateTimeSchema,
            });
        })(Get.Response || (Get.Response = {}));
    })(Get = Account.Get || (Account.Get = {}));
    (function (Create) {
        (function (Response) {
            Response.schema = Get.Response.schema.extend({
                quote: z
                    .object({
                    id: suretyQuoteId,
                    status: suretyQuoteStatusSchema,
                })
                    .optional(),
            });
        })(Create.Response || (Create.Response = {}));
    })(Account.Create || (Account.Create = {}));
    (function (Underwriting) {
        (function (Get) {
            (function (Response) {
                Response.schema = z.object({
                    id: suretyAccountUnderwritingId,
                    status: suretyAccountUnderwritingStatusSchema,
                    reviewReasons: z.array(z.object({ description: z.string() })),
                    score: z.number().optional(),
                    completenessScore: z.number().optional(),
                    singleLimit: z.number().optional(),
                    aggregateLimit: z.number().optional(),
                    expired: z.boolean(),
                    expiresAt: isoDateTimeSchema.optional(),
                    createdAt: isoDateTimeSchema,
                    availableModelSizes: z.array(contractSuretyAccountUnderwritingModelSizeSchema),
                    modelSize: contractSuretyAccountUnderwritingModelSizeSchema,
                    stale: z.boolean(),
                });
            })(Get.Response || (Get.Response = {}));
        })(Underwriting.Get || (Underwriting.Get = {}));
    })(Account.Underwriting || (Account.Underwriting = {}));
})(Account || (Account = {}));

export { Account };
